module.exports = __webpack_public_path__ + "img/hr-wooden-particle-shadow-23.67ed678b.png";